import {ParticleContainer} from "pixi.js";
import {Emitter} from "pixi-particles";
import {TrailUtils} from "../utils/TrailUtils";
import {gsap} from "gsap";
import {Loner} from "../Loner";

export class Trail extends PIXI.Container {
    private _container:ParticleContainer;
    private _head:PIXI.Texture;
    private _emitter:Emitter;
    private _emitterPos:PIXI.Point;

    constructor(parent?:PIXI.Container, head?:PIXI.Texture) {
        super();
        this._head = Loner.assetLoader.getTextures("SpinSpinSpin/pinthewinTrailing")[0];
        this.init();
    }

    public play(source:PIXI.Point, dest:PIXI.Point, duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this._emitterPos = new PIXI.Point(source.x, source.y);
            this._emitter.updateOwnerPos(this._emitterPos.x, this._emitterPos.y);
            this._container.visible = true;
        });
        const obj:{ x:number, y:number, transformOrigin:string} = {x : source.x, y : source.y, transformOrigin : "50% 50%"};
        tl.add(gsap.to(obj, {
            x : dest.x,
            y : dest.y,
            ease : "none",
            onUpdate : (value) => {
                TrailUtils.updateTrail(30, this._emitterPos, this._emitter, new PIXI.Point(obj.x, obj.y));
            },
            duration : duration
        }));
        return tl;
    }

    public clearTrail():void {
        this._container?.parent?.removeChild(this._container);
    }


    private init():void {
        this._container = new ParticleContainer(5000, {
            position : true,
            rotation : false,
            uvs : false,
            tint : true
        });
        this._container.visible = false;
        this.addChild(this._container);
        this._emitter = new Emitter(this._container, [this._head], TrailUtils.emitterConfig);
    }

}